var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-block"},[_c('div',{class:_vm.title?'title':''},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("info"),_c('span',{staticClass:"alertInfo"},[_vm._v(_vm._s(_vm.alertInfo))])],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }